import React from 'react';

export const GuestlinkConfigContext = React.createContext({});
